const stringBooleanToBoolean = (str: Nilable<string | boolean>): boolean => {
	if (typeof str === 'boolean') {
		return str;
	}

	return str?.toLowerCase?.() === 'true';
};

export default stringBooleanToBoolean;
